<template>
  <div>
    <div class="paihang_box">
      <div class="content1">
        <div class="paihang_title">“城市轨道交通+领域知识” 赛题当前部分排行</div>
        <table>
            <thead>
              <tr>
                <th>当前排名</th>
                <th>队伍</th>
                <th>队长</th>
                <th>所属单位</th>
                <th>选择</th>
                <th>判断</th>
                <th>简答</th>
                <th>多模态选择</th>
                <th>多模态判断</th>
                <th>多模态简答</th>
                <th>Sum</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in rankList" :key="index">
                <td>{{ item['当前排名'] }}</td>
                <td>{{ item['队伍'] }}</td>
                <td>{{ item['队长'] }}</td>
                <td>{{ item['所属单位'] }}</td>
                <td>{{ item['选择'] }}</td>
                <td>{{ item['判断'] }}</td>
                <td>{{ item['简答'] }}</td>
                <td>{{ item['多模态选择'] }}</td>
                <td>{{ item['多模态判断'] }}</td>
                <td>{{ item['多模态简答'] }}</td>
                <td>{{ item['Sum'] }}</td>
              </tr>
            </tbody>
        </table>
        <p class="des">（本赛道第一期已截止）</p>
      </div>
    </div>
    <div class="previous_box1">
      <div class="previous_box1_title1">
        “城市轨道交通+领域知识” 赛题介绍
        <div class="previous_box1_title1_line"></div>
      </div>
      <div class="previous_box1_title1_content">
        <p>
          随着城市化进程的加速，城市轨道交通成为了缓解城市交通拥堵的重要手段之一。大模型在城市轨道交通设计、施工及运维全领域的应用展现了巨大的潜力，同时面临的风险也不容忽视，因此，对城市轨道交通行业的交通大模型专业性能评估工作需求迫切。为了准确评估大模型在城市轨道交通设计、施工及运维相关领域的能力，促进相关领域大模型的研究与发展，我们从一线工作者（业务实操人员）处理、思考和解决问题的角度出发，构建了一个全面的评估框架，包括不限于基础知识理解、技术规范遵循、创新设计与优化、问题诊断及解决等方面的多维度能力，实现对大模型在城市轨道交通领域能力的初步评价。
        </p>
        <p>
          该赛道由北京城建设计发展集团股份有限公司承办。
        </p>
        <!-- <div class="previous_png1"></div> -->
      </div>

      <div class="previous_box1_title2">
        任务介绍
        <div class="previous_box1_title2_line"></div>
      </div>
      <!-- <div class="previous_box1_title2_content"> -->
      <div class="previous_box1_title1_content">
        <!-- <p>
          <span>交通概念问答：</span
          >测试模型对于交通概念的记忆能力，通过问模型一个基础的交通概念，看模型是否能回答正确；问题格式为包含A/B/C/D这4个选项的单选题或者判断正确/错误的判断题；如"请判断下面的说法是否正确？只需要回答正确或错误即可；汽车吊车及其他轮式专用机械车允许牵引1辆挂车。请从下面的A、B、C、D四个答案中给问题选出一个正确答案；只需要回答选项名A或B或C或D即可；高速公路限速标志标明的最高时速不得超过多少公里？“A.120公里&emsp;&emsp;B.90公里&emsp;&emsp;C.100公里&emsp;&emsp;D.140公里”
        </p>
        <p>
          <span>交通规则问答：</span
          >测试模型对于交通规则的记忆能力，问题都是关于具体的交通规则，如车辆行驶相关规则、车辆管理相关规则等；问题格式包含单选题和判断题。
        </p>
        <p>
          <span>交通标志问答：</span
          >测试模型对于交通标志的记忆能力，给模型一张交通标志图和一个问题，模型需要明白该交通标志的具体含义同时做出正确的回答；问题格式包含单选题和判断题。
        </p>
        <p>
          <span>交通事故分析：</span
          >给模型一段交通事故描述的文本或者一张交通事故的图片，模型需要能从中分析出该交通事故发生的具体原因。
        </p>
        <p>
          <span>交通公众舆情分析：</span
          >给模型提供社会公众对于新颁发的交通规则/政策的意见或者对现有交通设置的不满，模型需要从中分析和总结出公众的真实诉求。
        </p>
        <p>
          <span>交通安全建议：</span
          >给模型提供出行计划或出行天气状况，模型可以提供合理的出行安全建议；给模型提供相关驾驶场景的图片，模型能分析出存在的交通安全隐患并提供合理的安全建议。
        </p>
        <p>
          <span>交通标志错误检测：</span
          >给模型提供交通标志图（交通标志线/交通指示牌等），模型可以分析出交通标志线的绘制或交通标识的设置是否合理，是否存在错误。
        </p>
        <p>
          <span>道路占用监测：</span
          >给模型道路的图片或者轨道的相关图片，模型可以分析道路是否存在非法占用的情形。
        </p>
        <p>
          <span>交通应急预案生成：</span
          >针对用户提出的不同场景，模型需要能生成合理的应急预案。
        </p>
        <p>
          <span>交通安全教育文案生成：</span
          >针对用户给出的不同受众群体和安全教育场景，模型需要能生成合理有用的安全教育文案。
        </p> -->
        <!-- <div class="chart"></div> -->
         <p>
          城市轨道交通+领域知识赛道由北京城建设计发展集团股份有限公司承办。
         </p>
         <p>
          评估体系包括评估模型对城市轨道交通领域的基础理论和概念的理解程度、模型能否根据给定的技术规范和安全要求设计合理的建设施工布局或运维方案、模型是否具备识别方案风险并提出新的解决方案能力等。
         </p>
         <p>
          本赛道的任务旨在使用人工智能大模型来解决城市轨道交通领域中的一系列实际问题，如常识理解、规范遵守、设计优化、方案制定等。
         </p>
      </div>

      <div class="previous_box1_title2">
        评测指标
        <div class="previous_box1_title2_line"></div>
      </div>
      <div class="previous_box1_title1_content">
        <p>
          评价方式分为两部分，即领域知识理解的有效性和创新性评价。
        </p>
        <p>
          有效性的评价主要采用精度、召回率等指标，而创新性则由专家评审团进行打分。
        </p>
        <p>
          最终成绩会根据上述几项分数加权得到。
        </p>
      </div>
      <!-- <div class="previous_box1_title2">
        评测流程
        <div class="previous_box1_title2_line"></div>
      </div>
      <div class="previous_box1_title1_content">
        <p>
          为了防止数据的直接泄漏，我们需要在您注册后提交申请测评的请求（单模态数据集和多模态数据集需要分开申请），同时您必须同意数据集的使用规范，然后我们将发送给您测试数据集，您得到结果后从网站提交您的结果；我们将尽快为您计算您模型的得分情况，无特殊要求外，我们会将测评结果添加到排行榜上。
        </p>
        <p><br /></p>
        <p>如果您想参与测评，您需要做：</p>
      </div> -->

    </div>
    <div class="previous_box2">
      <!-- <div class="previous_box2_title1">
        评测指标
        <div class="previous_box2_title1_line"></div>
      </div>
      <div class="previous_box2_title1_content">
        <p>
          <span>Accuracy：</span>
          对于有标准答案的单选题和判断题（T1～T3任务），我们抽取出模型预测中的相关答案后，根据标准答案计算Accuracy；
        </p>
        <p>
          <span>ROUGE：</span>
          对于文本生成类的任务（T4～T10任务），我们计算模型预测答案和参考答案的ROUGE-Chinese-L分数；
        </p>
        <p>
          <span>GPT-4-Eval：</span>
          对于文本生成类的任务（T4～T10任务），考虑到正确答案的不唯一性，我们调用GPT-4从答案的正确性/冗余性/流畅度/完整性这四个方面对模型预测的答案进行打分；
        </p>
      </div> -->

      <div class="previous_box2_title2">
        评测流程
        <div class="previous_box2_title2_line"></div>
      </div>
      <div class="previous_box2_title2_content">
        <p>
          为了防止数据的直接泄漏，我们需要在您注册后提交申请测评的请求（单模态数据集和多模态数据集需要分开申请），同时您必须同意数据集的使用规范，然后我们将发送给您测试数据集，您得到结果后从网站提交您的结果；我们将尽快为您计算您模型的得分情况，无特殊要求外，我们会将测评结果添加到排行榜上。
        </p>
        <p><br /></p>
        <p>如果您想参与测评，您需要做：</p>
        <div class="shouldDo">
          <ul>
            <li>
              <p>注册账号</p>
            </li>
            <li>
              <p>提交相应的测评申请</p>
            </li>
            <!-- <li>
              <p>同意数据使用协议</p>
            </li> -->
            <li>
              <p>拿到数据后对模型进行测试</p>
            </li>
            <li>
              <p>按照规定格式上传您的结果</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="previous_box3">
      <div class="bigBtnBox">
        <div class="btns">
          <!-- <div class="btn1" @click="apply">申请评测</div> -->
          <div class="btn1" @click="apply">申请评测</div>
        </div>
        <div class="btns">
          <!-- <div class="btn2" @click="isShow = true">结果上传</div> -->
          <div class="btn2" @click="tips">结果上传</div>
        </div>
        <div class="btns">
          <div class="btn3">当前排行榜</div>
        </div>
      </div>

      <div class="previous_box3_title1">
        数据来源
        <div class="previous_box3_title1_line"></div>
      </div>
      <div class="previous_box3_title1_content">
        <!-- <p>上述任务主要涉及两种模态：文本模态和图像模态。</p>
        <p>&emsp;</p>
        <p>
          对于文本模态的数据，我们的原始数据集的主要来源于互联网。例如，对于有标准答案的问答数据，我们检索了大量交通领域的相关试卷；对于的事故报道或者社会公众的反馈建议主要来自于各个新闻网站和相关的市政管理平台。此外，诸如应急计划之类的专业文章主要从各机构官网的相关链接中下载得到。
        </p>
        <p>
          对于图像模态的数据，我们采用基于关键字的查询从互联网中检索和选择赴符合条件的图像，同时保存图像标题或标题链接中的文本以供进一步分析。
        </p> -->
        <p>技术评测提供的训练集、测试集均取自公开的城市轨道交通项目文档、设计规范和技术标准等内容，并由比赛方邀请专业技术人员进行标注。初赛训练集包含多个项目的案例（共包括规范问题，标准问题，设计施工运维问题，测试集包含轨道交通行业相关的基础理论及实际项目的案例。</p>
      </div>

      <div class="previous_box3_title2">
        赛程安排
        <div class="previous_box3_title2_line"></div>
      </div>

      <!-- <div class="arrange">
        <ul>
          <li>
            <p class="frist_title">注册账号</p>
            <div class="frist_div">
              <div>2024.7.11</div>
              <div>-</div>
              <div>2024.7.30</div>
            </div>
          </li>
          <li>
            <p>提交相应的测评申请</p>
            <div>2024.7.11</div>
            <div>-</div>
            <div>2024.7.30</div>
          </li>
          <li>
            <p>同意数据使用协议</p>
            <div>2024.7.11</div>
            <div>-</div>
            <div>2024.7.30</div>
          </li>
          <li>
            <p>拿到数据后对模型进行测试</p>
            <div>2024.7.11</div>
            <div>-</div>
            <div>2024.7.30</div>
          </li>
          <li>
            <p>按照规定格式上传您的结果</p>
            <div>2024.7.11</div>
            <div>-</div>
            <div>2024.7.30</div>
          </li>
        </ul>
      </div> -->

      <div class="previous_box3_title1_content">
        <p>评测阶段：开启本分赛道比赛报名，发放数据集，用于编写模型进行训练和测试。该阶段限每天提交一次模型预测结果，开放排行榜。
        </p>
        <p>学术交流阶段：公布最终成绩，并开展技术交流和颁奖活动。
        </p>
      </div>

      <div class="previous_box3_title3">
        奖金设置
        <div class="previous_box3_title3_line"></div>
      </div>
      <div class="previous_box3_content">
        <div>
          <div class="bonus1">
            <p class="bonus1-text">1名 奖金15000元</p>
          </div>
        </div>
        <div>
          <div class="bonus2">
            <p class="bonus2-text">2名 奖金7500元</p>
          </div>
        </div>
        <div>
          <div class="bonus3">
            <p class="bonus3-text">3名 奖金5000元</p>
          </div>
        </div>
      </div>

      <div class="previous_box3_title1_content">
        <p>注：以上所有提及金额均为税前金额。
        </p>
        <p>
          获奖算法与系统的知识产权归参赛队伍所有，仅要求获奖团队提供算法与系统报告（包括方法说明、数据处理、参考文献和使用开源工具等信息）及团队成员名单，供颁奖会技术交流.
        </p>
      </div>
    </div>

    <div class="box3">
      <div class="title4">
        分赛道组织单位
        <div class="title4_line"></div>
      </div>
      <!-- <div class="dw">承办单位</div> -->
      <!-- <div></div> -->
      <!-- <mainUnits class="slot1">
        <template v-slot:picture>
          <img style="height: 100%; width: 100%" src="" alt="" />
        </template>
        <template v-slot:content>中国中文信息学会大模型与生成专委会</template>
        <template v-slot:english>
          <p style="margin-left: -0.45rem; text-wrap: nowrap;">
            Large Model and Generation Committee of Chinese Information Pro
          </p>
        </template>
      </mainUnits> -->
      <!-- <mainUnits class="slot2">
        <template v-slot:picture>
          <img style="height: 100%; width: 100%" src="" alt="" />
        </template>
        <template v-slot:content> 北京交通大学 </template>
        <template v-slot:english> Beijing Jiaotong University </template>
      </mainUnits> -->
      <div class="title5">承办单位</div>
      <div class="xb">
        <!-- <div>
          <mainUnits class="cb_slot1">
            <template v-slot:picture>
              <img style="height: 100%; width: 100%" src="" alt="" />
            </template>
            <template v-slot:content> 北京大学 </template>
            <template v-slot:english>Peking university</template>
          </mainUnits>
        </div> -->
        <div>
          <mainUnits class="div1">
            <!-- <template v-slot:picture>
              <img style="height: 100%; width: 100%" ; src="src/assets/img/bjcj.png" alt="" />
            </template> -->
            <template v-slot:content> 北京城建设计发展集团股份有限公司 </template>
            <!-- <template v-slot:english> Beijing Jiaotong University </template> -->
          </mainUnits>
        </div>
        <div>
          <mainUnits class="div2">
            <template v-slot:picture>
              <img style="height: 100%; width: 100%" src="" alt="" />
            </template>
            <template v-slot:content> 中国城市轨道交通协会</template>
            <!-- <template v-slot:english>China Academy of Railway Sciences</template> -->
          </mainUnits>
        </div>
        <div>
          <mainUnits class="div2_1">
            <template v-slot:picture>
              <img style="height: 100%; width: 100%" src="" alt="" />
            </template>
            <template v-slot:content> 青岛地铁集团有限公司</template>
            <!-- <template v-slot:english>China Academy of Railway Sciences</template> -->
          </mainUnits>
        </div>
        <div></div>
      </div>
      <div class="title6">协办单位</div>
      <div class="xb">
        <div>
          <mainUnits class="div3">
            <!-- <template v-slot:picture>
              <img style="height: 100%; width: 100%" ; src="src/assets/img/bjcj.png" alt="" />
            </template> -->
            <template v-slot:content> 北京神州数码云计算有限公司 </template>
            <!-- <template v-slot:english> Beijing Jiaotong University </template> -->
          </mainUnits>
        </div>
        <div>
          <mainUnits class="div4">
            <!-- <template v-slot:picture>
              <img style="height: 100%; width: 100%" ; src="src/assets/img/bjcj.png" alt="" />
            </template> -->
            <template v-slot:content> 北京坚果科技有限公司 </template>
            <!-- <template v-slot:english> Beijing Jiaotong University </template> -->
          </mainUnits>
        </div>
        <div>
          <mainUnits class="div3">
            <!-- <template v-slot:picture>
              <img style="height: 100%; width: 100%" ; src="src/assets/img/bjcj.png" alt="" />
            </template> -->
            <template v-slot:content> 佳都科技集团股份有限公司 </template>
            <!-- <template v-slot:english> Beijing Jiaotong University </template> -->
          </mainUnits>
        </div>
      </div>
      <div class="title6">评测委员</div>
      <div class="container">
      <div class="left">
        <div class="item">
          <h3 class="name">华福才</h3>
          <p>北京城建设计发展集团股份有限公司</p>
          <p>技术研究院院长</p>
        </div>
        <div class="item">
          <h3 class="name">邢春阳</h3>
          <p>青岛地铁集团有限公司</p>
          <p>集团副总工程师、设备技术部、信息管理部部长</p>
        </div>
        <div class="item">
          <h3 class="name">韩德志</h3>
          <p>北京城建设计发展集团股份有限公司</p>
          <p>技术研究院数字信息技术中心主任</p>
        </div>
        <div class="item">
          <h3 class="name">邵昕</h3>
          <p>北京城建设计发展集团股份有限公司</p>
          <p>技术研究院数字信息技术中心智慧化部副部长</p>
        </div>
      </div>
    </div>
    </div>

    <!-- <div class="gameButtomBg">
      <div class="gameButtomBg_title">
        联系我们
        <div class="gameButtomBg_line"></div>
        <p>如果您有任何问题，请联系neurips2024@alibaba.com</p>
        <div class="ourIcon"></div>
      </div>
      <div class="previous_box4_title1">
        论文引用格式
        <div class="previous_box4_title1_line"></div>
        <p>如果您有任何问题，请联系neurips2024@alibaba.com</p>
      </div>
    </div> -->
<!--
    <div v-if="isShow">
      <div class="black"></div>
      <div class="dialog">
        <div class="dialog_title">结果上传</div>
        <div class="dialog_cha" @click="dialogIsntShow"></div>
        <div class="content">
          <form action="post" name="upLoadFile">
            <input type="file" name="file" id="file" />
            <div class="fileClickDiv" @click="uploadFile">点击上传文件</div>
            <div class="selectFile">
              <div class="selectTitle">已选择文件</div>
              <div class="fileNmae" v-html="fileNameHtml"></div>
              <input name="submit" type="submit" id="submit" value="提交" />
            </div>
          </form>
        </div>
      </div>
    </div> -->

    <div v-if="isShow">
      <div class="black"></div>
      <div class="dialog">
        <div class="dialog_title">我的申请记录</div>
        <div class="dialog_cha" @click="closeIsShow"></div>

        <div class="content">
          <table>
            <thead>
              <tr>
                <th>时间</th>
                <th>队伍名称</th>
                <th>状态</th>
                <th>结果</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
              <tr>
                <td>2024年7月10日 13.54</td>
                <td>xxx</td>
                <td>已提交</td>
                <td>
                  <p>未上传</p>
                  <a @click="checkResfn">上传结果</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div v-show="resIsShow_res">
      <div class="res_black"></div>
      <div class="res_dialog">
        <div class="res_dialog_title">结果上传</div>
        <div class="res_dialog_cha" @click="dialogIsntShow"></div>
        <div class="res_content">
          <form action="post" name="upLoadFile">
            <input type="file" name="file" id="file" />
            <div class="res_fileClickDiv" @click="uploadFile">点击上传文件</div>
            <div class="res_selectFile">
              <div class="res_selectTitle">已选择文件</div>
              <div class="res_fileNmae" v-html="fileNameHtml"></div>
              <input name="submit" type="submit" id="submit" value="提交" />
            </div>
          </form>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import mainUnits from '@/views/mainUnits.vue'
import axios from 'axios'
export default {
  name: 'sub2Page',
  components: {
    mainUnits
  },
  data () {
    return {
      rankList: [],
      isShow: false,
      getFilename: '',
      fileDivValue: '',
      fileNameHtml: '',
      resIsShow_res: false
    }
  },
  created () {
    this.fetchRankData()
  },
  methods: {
    fetchRankData () {
      axios.get('/media/csv/sub2Page.csv?t=' + Date.now())
        .then(res => {
          this.rankList = this.parseCSV(res.data)
        })
        .catch(err => {
          console.error('Failed to load rank data', err)
        })
    },
    parseCSV (csvText) {
      const lines = csvText.trim().split(/\r?\n/)
      const result = []
      const headers = lines[0].split(',')
      for (let i = 1; i < lines.length; i++) {
        if (!lines[i]) continue
        const obj = {}
        const currentLine = lines[i].split(',')
        for (let j = 0; j < headers.length; j++) {
          obj[headers[j]] = currentLine[j]
        }
        result.push(obj)
      }
      return result
    },
    apply () {
      this.$store.commit('applyShowFn2', true)
    },
    closeIsShow () {
      this.isShow = false
    },
    dialogIsntShow () {
      this.resIsShow_res = false
    },
    checkResfn () {
      this.resIsShow_res = true
    },
    uploadFile () {
      const fileDiv = document.querySelector('#file')
      fileDiv.click()
      setInterval(() => {
        if (fileDiv.value !== this.fileDivValue) {
          const index = fileDiv.value.lastIndexOf('\\')
          // console.log(index)
          this.fileDivValue = fileDiv.value.slice(index + 1)
          this.fileNameHtml = this.fileDivValue
          // clearInterval(timmer)
        }
      }, 500)
    },
    tips () {
      alert('网站正在建设中，请进首页联系群获取报名邮箱')
    }
  }
//   submit_res () {
//     const fileDiv = document.querySelector('#file')
//     fileDiv.innerHTML = ''
//   }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: "FZLTZCHK";
  src: url("/src/assets/font/FZLTCHJW.TTF") format("truetype"); /* 使用webpack的别名&#126;@指向src目录 */
  font-weight: normal;
  font-style: normal;
}
.paihang_box {
  background: url(/src/assets/img/bg_for_paihang1.jpg) no-repeat;
  width:100%;
  height: 4.5rem;
}
.paihang_title {
  text-align: center;
    padding-top: 0.9rem;
    // width: 7.27rem;
    height: 0.3rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
}
.previous_box1 {
  width: 100%;
  height: 12rem;
  background: url(/src/assets/img/previous_box1_bg_half.png) no-repeat;
  background-size: 100% 100%;
  .previous_box1_title1 {
    text-align: center;
    padding-top: 0.9rem;
    // width: 7.27rem;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    .previous_box1_title1_line {
      margin: 0.15rem auto;
      margin-left: 4.4rem;
      width: 7rem;
      height: 0.05rem;
      background: url(/src/assets/img/title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .previous_box1_title1_content {
    width: 11.5rem;
    // background-color: pink;
    margin: 1rem auto;
    p {
      font-family: FZLTZCHK;
      color: #333333;
      font-size: 0.17rem;
      text-indent: 2em;
      line-height: 0.3rem;
    }
    .previous_png1 {
      background: url(/src/assets/img/previous1.png) no-repeat;
      background-size: 100% 100%;
      width: 8.5rem;
      height: 3.3rem;
      margin: 0 auto;
      margin-top: 0.5rem;
    }
  }
  .previous_box1_title2 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
  }
  .previous_box1_title2_line {
    margin: 0.15rem auto;
    width: 2.15rem;
    height: 0.05rem;
    background: url(/src/assets/img/game_title1_line.png) no-repeat;
    background-size: 100% 100%;
  }
  .previous_box1_title2_content {
    width: 11.5rem;
    margin: 0 auto;
    margin-top: 0.7rem;
    p {
      font-family: FZLTZCHK;
      color: #333333;
      font-size: 0.23rem;
      line-height: 0.46rem;
      span {
        color: #2266ff;
        &::before {
          display: inline-block;
          content: "";
          width: 0.2rem;
          height: 0.25rem;
          transform: translateY(0.05rem);
          background: url(/src/assets/img/list_style2.png) no-repeat;
          margin-right: 0.15rem;
          background-size: 100% 100%;
        }
      }
    }
    .chart {
      background: url(/src/assets/img/chart.png) no-repeat;
      background-size: 100% 100%;
      width: 4.4rem;
      height: 4.4rem;
      margin: 0.8rem auto;
    }
  }
}
.des {
  font-size: 0.15rem;
}
.previous_box2 {
  width: 100%;
  height: 13.8rem;
  background: url(/src/assets/img/previous_box2_bg.png) no-repeat;
  background-size: 100% 100%;
  .previous_box2_title1 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 1.6rem;
  }
  .previous_box2_title1_line {
    margin: 0.15rem auto;
    width: 2.15rem;
    height: 0.05rem;
    background: url(/src/assets/img/game_title1_line.png) no-repeat;
    background-size: 100% 100%;
  }
  .previous_box2_title1_content {
    width: 11.5rem;
    margin: 0 auto;
    margin-top: 0.7rem;
    p {
      font-family: FZLTZCHK;
      color: #333333;
      font-size: 0.2rem;
      line-height: 0.36rem;
      text-align: center;
      span {
        color: #2266ff;
      }
    }
  }
  .previous_box2_title2 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 1.8rem;
    .previous_box2_title2_line {
      margin: 0.15rem auto;
      width: 2.15rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .previous_box2_title2_content {
    width: 11.5rem;
    margin: 0 auto;
    margin-top: 0.7rem;
    p {
      font-family: FZLTZCHK;
      color: #333333;
      font-size: 0.2rem;
      line-height: 0.36rem;
      text-indent: 2em;
    }
  }
  .shouldDo {
    ul {
      transform: translateX(-0.63rem);
      width: 12rem;
      height: 2.1rem;
      padding: 0.4rem;
      // margin: 0 auto;
      margin-top: 0.2rem;
      // background-color: pink;
      li {
        float: left;
        list-style: none;
        margin: 0 0.2rem;
        height: 1.2rem;
        width: 1.2rem;
        background: radial-gradient(circle, #e0efff 0%, #f5f9ff 100%);
        box-shadow: 0 0.05rem 0.38rem 0.05rem #b1c6e8;
        border-radius: 0.22rem 0.22rem 0.22rem 0.22rem;
        padding: 0.2rem 0.4rem;
        text-align: center;
        p {
          //   font-size: 0.2rem;
          font-family: FZLTZCHK;
          //   width: 1rem;
          color: #5d8fff;
          text-indent: 0;
          &:first-child {
            transform: translateY(0.23rem);
          }
        }
        // transform: translateY(0.2rem);
      }
    }
  }
}
.previous_box3 {
  width: 100%;
  height: 25.6rem;
  background: url(/src/assets/img/previous_box3_bg.png) no-repeat;
  background-size: 100% 100%;
  .bigBtnBox {
    width: 11.5rem;
    // background-color: pink;
    margin: 0 auto;
    padding-top: 1rem;
    .btns {
      float: left;
      width: 2.8rem;
      height: 1rem;
      background: linear-gradient(#e0efff, #f5f9ff);
      margin: 0.35rem;
      transform: translateX(0.5rem);
      box-shadow: 0 0.05rem 0.38rem 0.05rem #b1c6e8;
      .btn1,
      .btn2,
      .btn3 {
        font-size: 0.32rem;
        color: #2266ff;
        // padding: 0.3rem;
        text-align: center;
        line-height: 1rem;
        font-family: FZLTZCHK;
        cursor: pointer;
      }
      .btn1 {
        transform: translateY(-0.1rem);
        &::before {
          display: inline-block;
          content: "";
          background: url(/src/assets/img/icon1.png) no-repeat;
          background-size: 100% 100%;
          height: 0.7rem;
          width: 0.6rem;
          transform: translateY(0.25rem);
          margin-right: 0.2rem;
        }
      }
      .btn2 {
        transform: translateY(-0.2rem);
        &::before {
          display: inline-block;
          content: "";
          background: url(/src/assets/img/icon2.png) no-repeat;
          background-size: 100% 100%;
          height: 0.8rem;
          width: 0.8rem;
          transform: translateY(0.25rem);
          margin-right: 0.2rem;
        }
      }
      .btn3 {
        transform: translateY(-0.02rem);
        &::before {
          display: inline-block;
          content: "";
          background: url(/src/assets/img/icon3.png) no-repeat;
          background-size: 100% 100%;
          height: 0.63rem;
          width: 0.74rem;
          transform: translateY(0.22rem);
          margin-right: 0.2rem;
        }
      }
    }
  }
  .previous_box3_title1 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 2.8rem;
    .previous_box3_title1_line {
      margin: 0.15rem auto;
      width: 2.15rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .previous_box3_title1_content {
    width: 11.5rem;
    margin: 0 auto;
    margin-top: 0.8rem;
    p {
      font-family: FZLTZCHK;
      color: #333333;
      font-size: 0.2rem;
      line-height: 0.36rem;
      text-indent: 2em;
    }
  }
  .previous_box3_title2 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 1rem;
    .previous_box3_title2_line {
      margin: 0.15rem auto;
      width: 2.15rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .arrange {
    margin: 0 auto;
    width: 12rem;
    ul {
      transform: translateX(-0.4rem);
      width: 12rem;
      height: 2.1rem;
      padding: 0.4rem;
      // margin: 0 auto;
      margin-top: 0.4rem;
      // background-color: pink;
      li {
        float: left;
        list-style: none;
        margin: 0 0.2rem;
        height: 1.6rem;
        width: 1.2rem;
        background: radial-gradient(circle, #e0efff 0%, #f5f9ff 100%);
        box-shadow: 0 0.05rem 0.38rem 0.05rem #b1c6e8;
        border-radius: 0.22rem 0.22rem 0.22rem 0.22rem;
        padding: 0.2rem 0.4rem;
        text-align: center;
        p {
          font-size: 0.2rem;
          font-family: FZLTZCHK;
          // width: 1.1rem;
          color: #5d8fff;
          text-indent: 0;
          &:first-child {
            transform: translateY(0.1rem);
          }
        }
        // transform: translateY(0.2rem);
        div {
          font-size: 0.2rem;
          font-family: FZLTZCHK;
          text-indent: 0;
          transform: translateY(0.4rem);
          text-align: center;
          font-style: italic;
        }
        .frist_title {
          padding-top: 0.1rem;
        }
      }
      .frist_div div {
        font-size: 0.2rem;
        font-family: FZLTZCHK;
        text-indent: 0;
        transform: translateY(0.1rem);
        text-align: center;
        font-style: italic;
      }
    }
  }
  .previous_box3_title3 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 1rem;
    .previous_box3_title3_line {
      margin: 0.15rem auto;
      width: 2.15rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
  .previous_box3_content {
    width: 11.4rem;
    // background-color: pink;
    margin: 0 auto;
    div {
      transform: translateX(-0.112rem);
      display: inline-block;
      height: 3rem;
      width: 3rem;
      // background-color: #2266ff;
      margin: 0.4rem 0.35rem;
      .bonus1 {
        background: url(/src/assets/img/bonus1.png) no-repeat;
        background-size: 100% 100%;
        .bonus1-text { /* 新增类来专门设置p元素的样式 */
          position: absolute; /* 绝对定位p元素 */
          top: 50%; /* 将p元素的上边缘放置在bonus1元素垂直中心 */
          left: 50%; /* 将p元素的左边缘放置在bonus1元素水平中心 */
          transform: translate(-50%, -50%); /* 使用transform来居中p元素 */
          width: 100%; /* 使p元素的宽度与bonus1相同 */
          text-align: center; /* 水平居中文本 */
          color: #000000; /* 设置文本颜色 */
          font-size: 0.2rem; /* 设置字体大小 */
        }
      }
      .bonus2 {
        background: url(/src/assets/img/bonus2.png) no-repeat;
        background-size: 100% 100%;
        .bonus2-text { /* 新增类来专门设置p元素的样式 */
          position: absolute; /* 绝对定位p元素 */
          top: 50%; /* 将p元素的上边缘放置在bonus1元素垂直中心 */
          left: 50%; /* 将p元素的左边缘放置在bonus1元素水平中心 */
          transform: translate(-50%, -50%); /* 使用transform来居中p元素 */
          width: 100%; /* 使p元素的宽度与bonus1相同 */
          text-align: center; /* 水平居中文本 */
          color: #000000; /* 设置文本颜色 */
          font-size: 0.2rem; /* 设置字体大小 */
        }
      }
      .bonus3 {
        background: url(/src/assets/img/bonus3.png) no-repeat;
        background-size: 100% 100%;
        .bonus3-text { /* 新增类来专门设置p元素的样式 */
          position: absolute; /* 绝对定位p元素 */
          top: 50%; /* 将p元素的上边缘放置在bonus1元素垂直中心 */
          left: 50%; /* 将p元素的左边缘放置在bonus1元素水平中心 */
          transform: translate(-50%, -50%); /* 使用transform来居中p元素 */
          width: 100%; /* 使p元素的宽度与bonus1相同 */
          text-align: center; /* 水平居中文本 */
          color: #000000; /* 设置文本颜色 */
          font-size: 0.2rem; /* 设置字体大小 */
        }
      }
    }
  }
}
.gameButtomBg {
  background: url(/src/assets/img/perv_buttomBg.png) no-repeat;
  background-size: 100% 100%;
  height: 8rem;
  width: 100%;
  margin-top: -3rem;
  .gameButtomBg_title {
    text-align: center;
    transform: translateY(-3rem);
    // width: 6rem;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
  }
  .gameButtomBg_line {
    margin: 0.15rem auto;
    width: 2.15rem;
    height: 0.05rem;
    background: url(/src/assets/img/game_title1_line.png) no-repeat;
    background-size: 100% 100%;
  }
  p {
    margin-top: 0.45rem;
    height: 0.24rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.22rem;
    color: #000000;
    line-height: 0.43rem;
  }
  .ourIcon {
    width: 2.03rem;
    height: 2rem;
    margin: 0 auto;
    margin-top: 0.8rem;
    background: #d2e9fe;
    box-shadow: 0.02rem 0.02rem 0.06rem 0.01rem rgba(130, 195, 255, 0.55);
    border-radius: 0.39rem;
  }
  .previous_box4_title1 {
    text-align: center;
    height: 0.38rem;
    font-family: FZLTZCHK;
    font-weight: normal;
    font-size: 0.4rem;
    color: #333333;
    line-height: 0.38rem;
    padding-top: 2rem;
    .previous_box4_title1_line {
      margin: 0.15rem auto;
      width: 3rem;
      height: 0.05rem;
      background: url(/src/assets/img/game_title1_line.png) no-repeat;
      background-size: 100% 100%;
    }
  }
}
.box3 {
    position: relative;
    width: 100%;
    height: 43rem;
    background: url(/src/assets/img/bg3.png) no-repeat;
    background-size: 100% 100%;
    margin: 0 auto;
    min-width: var(--content-width);
    .title4 {
      text-align: center;
      margin-top: 0.9rem;
      // width: 7.27rem;
      height: 0.38rem;
      font-family: FZLTZCHK;
      font-weight: normal;
      font-size: 0.4rem;
      color: #333333;
      line-height: 0.38rem;
      .title4_line {
        margin: 0.15rem auto;
        width: 8.8rem;
        height: 0.05rem;
        background: url(/src/assets/img/title4_line.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    .dw,
    .title5,
    .title6,
    .hzdw,
    .zcdw {
      margin: 0.8rem auto;
      text-align: center;
      // width: 1.4rem;
      height: 0.33rem;
      font-family: FZLTZCHK;
      font-weight: normal;
      font-size: 0.34rem;
      color: #333333;
      line-height: 0.68rem;
      text-shadow: 0.01rem 0.07rem 0 rgba(183, 162, 208, 0.55);
    }
    .slot1,
    .slot2,
    .slot3,
    .slot4 {
      margin: 0.5rem auto;
    }
    .cb,
    .xb {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      flex-wrap: nowrap;
      margin: 0 auto;
      width: 11.13rem;
      // background-color: pink;
      align-items: center;
      .div1 {
        //flex: 1;
        //margin: 0 auto;
        // text-align: center;
        flex: 0 1 auto; /* 修改这里，确保 div 不扩展 */
        margin: 0 0.6rem; /* 修改这里，给 div 添加左右外边距 */
        // background: url(/src/assets/img/title4_line.png) no-repeat;
      }
      .div2 {
        //flex: 1;
        //margin: 0 auto;
        // text-align: center;
        flex: 0 1 auto; /* 修改这里，确保 div 不扩展 */
        margin: 0 0.8rem; /* 修改这里，给 div 添加左右外边距 */
      }
      .div2_1 {
        //flex: 1;
        //margin: 0 auto;
        // text-align: center;
        flex: 0 1 auto; /* 修改这里，确保 div 不扩展 */
        margin: 0 0.8rem; /* 修改这里，给 div 添加左右外边距 */
      }
      .div3 {
        //flex: 1;
        //margin: 0 auto;
        // text-align: center;
        flex: 0 1 auto; /* 修改这里，确保 div 不扩展 */
        margin: 0 0.8rem; /* 修改这里，给 div 添加左右外边距 */
      }
      .div4 {
        //flex: 1;
        //margin: 0 auto;
        // text-align: center;
        flex: 0 1 auto; /* 修改这里，确保 div 不扩展 */
        margin: 0 0.8rem; /* 修改这里，给 div 添加左右外边距 */
      }
    }
  }

// 弹框控制
.dialog {
  height: 65%;
  width: 40%;
  max-height: 8rem;
  background-color: #fff;
  z-index: 3;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // box-shadow: 0.06rem 0.06rem 0.06rem 0.06rem rgba(130, 195, 255, 0.55);
  border-radius: 0.1rem;
  .content {
    position: relative;
    height: 80%;
    width: 80%;
    // background-color: pink;
    margin: 0 auto;
    table {
      margin: 0.3rem auto;
      text-align: center;
      font-size: 0.14rem;
      font-family: FZLTZCHK;
      width: 100%;
      border: 0.02rem solid #a2d0ff;
      border-collapse: collapse;
      border-radius: 0.12rem;
      thead tr th,
      tbody tr td {
        padding: 0.05rem;
        border: 0.02rem solid #a2d0ff;
      }
      thead tr th {
        border: 0;
        color: #fff;
        background-color: #9dceff;
      }
      tbody tr td {
        a {
          border-bottom: 1px solid red;
          cursor: pointer;
          color: red;
        }
      }
    }
  }
  .dialog_title {
    font-size: 0.3rem;
    font-family: FZLTZCHK;
    padding-top: 0.3rem;
    padding-left: 0.3rem;
  }
}
.content1 {
  width: 90%;
  height: 8.2rem;
  // box-shadow: rgba(99, 99, 99, 0.2) 0px 0.02rem 0.08rem 0px;
  margin: 0 auto;
  position: relative;
  table {
    margin: 0.3rem auto;
    text-align: center;
    font-size: 0.14rem;
    font-family: FZLTZCHK;
    width: 100%;
    border: 0.02rem solid #a2d0ff;
    border-collapse: collapse;
    border-radius: 0.12rem;
    thead tr th,
    tbody tr td {
      padding: 0.05rem;
      border: 0.02rem solid #a2d0ff;
    }
    thead tr th {
      border: 0;
      color: #ffffff;
      background-color: #9dceff;
    }
    tbody tr td {
      a {
        border-bottom: 1px solid red;
        cursor: pointer;
        color: red;
      }
    }
  }
}
.black {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 2;
}
.dialog_cha {
  position: absolute;
  top: 0.33rem;
  right: 0.33rem;
  height: 0.23rem;
  width: 0.23rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}

// 上传结果弹框控制
.res_dialog {
  height: 10rem;
  width: 10rem;
  max-height: 350px;
  max-width: 458px;
  background-color: #fff;
  z-index: 5;
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  // box-shadow: 0.06rem 0.06rem 0.06rem 0.06rem rgba(130, 195, 255, 0.55);
  border-radius: 0.1rem;
  .res_content {
    position: relative;
    height: 80%;
    width: 80%;
    // background-color: pink;
    margin: 0 auto;
  }
  .res_dialog_title {
    font-size: 0.3rem;
    font-family: FZLTZCHK;
    padding-top: 0.3rem;
    padding-left: 0.3rem;
  }
}
.res_black {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 5;
}
.res_dialog_cha {
  position: absolute;
  top: 0.33rem;
  right: 0.33rem;
  height: 0.23rem;
  width: 0.23rem;
  background: url(/src/assets/img/cancel.png) no-repeat;
  background-size: 100%;
  cursor: pointer;
}
#file {
  display: none;
}
.res_fileClickDiv {
  position: absolute;
  text-align: center;
  width: 80%;
  height: 16%;
  // padding-top: 10%;
  line-height: 0.5rem;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  font-family: FZLTZCHK;
  font-size: 0.21rem;
  color: #fff;
  background-color: #74b9ff;
  border-radius: 0.08rem;
  box-shadow: rgba(149, 157, 165, 0.2) 0 0.08rem 0.24rem;
  border: 0;
  cursor: pointer;
  &::before {
    display: inline-block;
    content: "";
    height: 0.25rem;
    width: 0.25rem;
    background: url(/src/assets/img/upLoadIcon.png) no-repeat;
    background-size: 100% 100%;
    transform: translateY(0.05rem);
    margin-right: 0.1rem;
  }
}

#submit {
  position: absolute;
  right: 0.1rem;
  bottom: 0.1rem;
  color: #fff;
  background-color: #74b9ff;
  border-radius: 0.08rem;
  font-size: 20%;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 0.08rem 0.24rem;
  border: 0;
  height: 20%;
  width: 30%;
}

.res_selectFile {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  height: 60%;
  width: 80%;
  background-color: #fff;
  border-radius: 0.08rem;
  box-shadow: rgba(149, 157, 165, 0.4) 0px 0.08rem 0.24rem;
  border: 0;
  .res_selectTitle {
    position: absolute;
    top: 8%;
    left: 8%;
    font-size: 0.15rem;
    color: #454545;
    font-family: FZLTZCHK;
  }
  .res_fileNmae {
    position: absolute;
    top: 30%;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    height: 20%;
    font-size: 20%;
    padding: 0 0.1rem;
    line-height: 0.4rem;
    border-radius: 0.08rem;
    font-family: FZLTZCHK;
    overflow: hidden;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 0.02rem 0.08rem 0px;
  }
}
.btn_apply {
  position: absolute;
  bottom: 0.2rem;
  right: 1rem;
  width: 1rem;
  height: 0.4rem;
  font-family: FZLTZCHK;
  background-color: #74b9ff;
  color: #fff;
  border-radius: 0.08rem;
//   margin-left: 1rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border: 0;
  margin-top: 1.5rem;
  cursor: pointer;
}
.btn_new {
  position: absolute;
  bottom: 0.2rem;
  right: -0.2rem;
  width: 1rem;
  height: 0.4rem;
  font-family: FZLTZCHK;
  background-color: #74b9ff;
  color: #fff;
  border-radius: 0.08rem;
  margin-left: 0.45rem;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border: 0;
  cursor: pointer;
}
.container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.left {
  // background-color: pink;
  flex: 1;
  //margin-right: 2em;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
}
.right {
  flex: 1;
  margin-left: 2em;
}
.item {
  // padding内边距
  border-radius: 5px;
  margin: 0rem;
  width: 100%;
}
.name {
  font-weight: bold;
  font-size: 0.2rem;
  // margin-left: auto;
  // margin-right: auto;
  text-align: center;
  width: 100%;
}
.item p {
  font-size: 0.15rem; /* 0.5rem 相当于 8px（假设默认字体大小为 16px） */
  // background-color: #14614c;
  text-align: center;
  white-space: nowrap;
}
</style>
